'use strict';


module.exports = function xorString ( data, key ) {
    var index = 0,
        size = data.length,
        encoded = [],
        keyIndex;

    encoded.length = size;

    while ( index < size ) {
        keyIndex = index % key.length;
        /* eslint no-bitwise: 0 */
        encoded[index] = (String.fromCharCode(data.charCodeAt(index) ^ key.charCodeAt(keyIndex)));
        ++index;
    }

    return encoded.join('');
};
